<template>
    <div>
        <textarea-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
        />

        <text-form-group
                v-model="data.author_name"
                name="author_name"
                label="Author Name"
                :error="(errors.author_name || [])[0]"
        />

        <text-form-group
                v-model="data.author_title"
                name="author_title"
                label="Author Title"
                :error="(errors.author_title || [])[0]"
        />

        <gallery-form-group
                v-model="data.author_image_id"
                name="author_image_id"
                label="Author Image"
                :error="(errors.author_image_id || [])[0]"
        />

        <gallery-form-group
                v-model="data.company_image_id"
                name="company_image_id"
                label="Company Image"
                :error="(errors.company_image_id || [])[0]"
        />
    </div>
</template>

<script>
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
    import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

    export default {
        components: {GalleryFormGroup, TextFormGroup, TextareaFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
